module.exports = __webpack_public_path__ + "static/strategy.32bd4a13.jpg";